export const listBottom = [
    {
        name: 'Отрасль',
        description: 'Финтех',
    },
    {
        name: 'услуги',
        description: 'SEO продвижение',
    },
];

export const listStages = [
    {
        number: '1.',
        text: 'Собрали семантическое ядро.',
    },
    {
        number: '2.',
        text: 'Провели технический аудит сайта.',
    },
    {
        number: '3.',
        text: 'Разработали стратегию SEO-продвижения.',
    },
    {
        number: '4.',
        text: 'Добавили сервисы мониторинга и&nbsp;отслеживания.',
    },
    {
        number: '5.',
        text: 'Сформировали техническое задание с&nbsp;приоритезацией.',
    },
    {
        number: '6.',
        text: 'Оптимизировали мета-теги приоритетных категорий.',
    },
    {
        number: '7.',
        text: 'Обновили контент.',
    },
    {
        number: '8.',
        text: 'Мониторили трафик и&nbsp;позиции сайта в&nbsp;поисковых системах.',
    },
];

export const listStagesAudit = [
    {
        number: '1.',
        text: 'серьезные ошибки в&nbsp;оптимизации мета-тегов и&nbsp;заголовков&nbsp;h1;',
    },
    {
        number: '2.',
        text: 'внутренняя перелинковка нуждалась в&nbsp;значительной доработке;',
    },
    {
        number: '3.',
        text: 'низкая скорость загрузки сайта;',
    },
    {
        number: '4.',
        text: 'на сайте отсутствовала микроразметка;',
    },
    {
        number: '5.',
        text: 'мало оптимизированного контента на&nbsp;сайте;',
    },
    {
        number: '6.',
        text: 'большое количество внутренних ссылок с&nbsp;404 и&nbsp;301 кодом ответа.',
    },
];

export const listRecommendations = [
    {
        number: '1.',
        text: 'Улучшить информационную составляющую посадочных страниц.',
    },
    {
        number: '2.',
        text: 'Уделить особое внимание проверке корректности структуры сайта.',
    },
    {
        number: '3.',
        text: 'Развивать внутреннюю перелинковку на&nbsp;сайте, особое внимание уделить анкорам ссылок, имеют&nbsp;ли они релевантные ключи.',
    },
    {
        number: '4.',
        text: 'Создавать посадочные страницы под узкоспециализированные и&nbsp;региональные запросы.',
    },
    {
        number: '5.',
        text: 'Готовить решения для развития внешнего ссылочного профиля естественным путем.',
    },
];

export const listResults = [
    {
        number: '1.',
        text: 'Точечная работа с&nbsp;отстающими высокочастотными и&nbsp;среднечастотными запросами.',
    },
    {
        number: '2.',
        text: 'Создание новых посадочных и&nbsp;региональных страниц.',
    },
    {
        number: '3.',
        text: 'Аналитика посадочных страниц конкурентов и&nbsp;работа с&nbsp;ссылочным профилем сайта на&nbsp;основе анализа.',
    },
    {
        number: '4.',
        text: 'Работа с&nbsp;контентом и&nbsp;его оптимизация.',
    },
    {
        number: '5.',
        text: 'Регулярный мониторинг технических ошибок на&nbsp;сайте и&nbsp;передача их&nbsp;в&nbsp;работу разработчикам.',
    },
];

export const listResultsStatisticMetrics = [
    {
        text: 'Рост позиций топ-30 Google',
        icon: '/images/pic/otp-bank/google_icon.jpg',
        number: '+43%',
    },
    {
        text: 'Рост позиций топ-30 Яндекс',
        icon: '/images/svg/otp-bank/yandex_icon.svg',
        number: '+30%',
    },
];

export const listResultsStatisticDetail = [
    {
        text: 'Вклады',
        icon: '/images/svg/otp-bank/contributions.svg',
        number: '40%',
    },
    {
        text: 'Кредиты',
        icon: '/images/svg/otp-bank/credits.svg',
        number: '49%',
    },
    {
        text: 'Малый бизнес',
        icon: '/images/svg/otp-bank/business.svg',
        number: '55%',
    },
];

export const listGraphic = [
    {
        number: '1',
        text: 'Исправление основных технических проблем сайта',
    },
    {
        number: '2',
        text: 'Сбор и&nbsp;постепенное расширение актуальной семантики',
    },
    {
        number: '3',
        text: 'Расширение структуры, добавление новых страниц',
    },
    {
        number: '4',
        text: 'Исправление ошибок внутренней оптимизации',
    },
    {
        number: '5',
        text: 'Анализ и&nbsp;оптимизация сайта',
    },
];

export const listStrategy = [
    {
        text: 'Кредиты',
        icon: '/images/svg/otp-bank/credits.svg',
        number: '+58%',
    },
    {
        text: 'Малый бизнес',
        icon: '/images/svg/otp-bank/business.svg',
        number: '+33%',
    },
    {
        text: 'Вклады',
        icon: '/images/svg/otp-bank/contributions.svg',
        number: '+18%',
    },
];
